import axios from "axios";

// ─────────────────────────────────────────────
// Base axios instance — all API calls go through this.
// Automatically attaches JWT token to every request.
// ─────────────────────────────────────────────
const api = axios.create({
baseURL: process.env.REACT_APP_API_URL || "https://api.suvidhaeldercare.com/api",
});

// ✅ Correct

// Before every request → attach token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// After every response → if 401, token expired → redirect to login
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;

export const setAuthToken = (token) => {
  if (token) localStorage.setItem("token", token);
  else localStorage.removeItem("token");
};